import { create } from "zustand";
import { CallSessionState, CallSessionActions } from "./types";
import { CallSession } from "@/common/models/callSession";

export const useCallSessionStore = create<
	CallSessionState & CallSessionActions
>((set) => ({
	callSession: null,
	update: (callSession: CallSession | null) =>
		set({ callSession: callSession }),
}));
